module.exports = __webpack_public_path__ + "img/75ne.0f1f6e7b.svg";